<template>
    <div class="row">
        <div class="col-xs-12">
            <div class="form-field">
                <input-field :id="'checkedListboxSearch' + name" v-model="search" :placeholder="$t('message.consulta')">
                    {{ $t('message.buscar') }}
                </input-field>
            </div>
        </div>
        <div class="col-xs-12">
            <p>
                <label :for="'seleccionarTodo' + name"><input @change="seleccionarTodos" v-model="todos" type="checkbox" :id="'seleccionarTodo' + name"/> <span>{{ $t('message.seleccionarTodos') }}</span></label>
            </p>
        </div>
        <div v-show="similiarToSearch(item[label])" :key="index" v-for="(item, index) in items" :class="classColumn">
            <label :for="name.toString() + index.toString()">
                <input @change="$emit('input', modelValue)" v-model="modelValue" :value="item[field]" type="checkbox" :name="name" :id="name.toString() + index.toString()"> <span>{{ item[label] }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        columns : {
            type : Number, 
            required : false, 
            default : 2
        },
        name : {
            type : String,
            required : false,
            default : ''
        },
        items : {
            type : Array,
            required : true,
            default : function () {
                return [];
            }
        },
        value : {
            type : Array, 
            required : false, 
            default : function () {
                return [];
            }
        },
        label : {
            type : String,
            required : false,
            default : 'descripcion'
        },
        field : {
            type : String,
            required : false,
            default : 'id'
        }
    },
    data : function () {
        return {
            search : '',
            modelValue : this.value,
            todos : false,
            classColumn: `col-xs-12 col-md-${12/this.columns}`
        };
    },
    methods : {
        similiarToSearch : function (value) {
            if (this.search === '')
                return true;
            else 
                return value.toUpperCase().indexOf(this.search.toUpperCase()) != -1;
        },
        seleccionarTodos : function () {
            this.modelValue = [];
            if (this.todos)
            {
                for (let i = 0; i < this.items.length; i++)
                    this.modelValue.push(this.items[i][this.field]);
                this.$emit('input', this.modelValue);
            }
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = value;
        }
    },
    mounted : function () {
        // const divColumnas = document.getElementById("nColumnas");
        // divColumnas.classList.add('col-md-4');
        // const columnas = 12/this.columns;
        // divColumnas.setAttribute("class", `col-md-2`);
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/CheckedListbox.vue